import {Fancybox} from "@fancyapps/ui";

export default function initializeFancybox() {
  Fancybox.bind("[data-fancybox]", {
    Toolbar: {
      display: [
        "fullscreen",
        "thumbs",
        "close",
      ],
    },
  });
}
